import { atom } from "jotai";
import EventEmitter from "eventemitter3";

export const eventsAtom = atom<EventEmitter>(new EventEmitter());
